module.exports = __webpack_public_path__ + "assets/view_on.24f02253.svg";